var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGarudaIndonesiaLogowine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    id: "svg9594",
    xmlSpace: "preserve",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "-4349.7396 -1335.2635 37697.7432 8011.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9546"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style9544",
    type: "text/css"
  }, ".fil0{fill-rule:nonzero}.fil1{fill:#202d5c}.fil1,.fil2{fill-rule:nonzero}.fil0{fill:#358e9d}.fil2{fill:#474343}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .054)",
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g6656"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24222 2222c-582-304-1065-327-1291-327h-786l-42-74h924c64 0 830-11 1281 110 564 151 954 447 1030 497 76 49 1105 786 1105 786s-173 177-342 177c-160 0-333-123-333-123s-551-397-635-456-519-383-912-589z",
    className: "fil0",
    id: "path6658"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6660"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24180 2803c389 258 618 447 693 501 74 54 420 301 420 301s159 124 354 124c148 0 330-172 330-172s-826-583-901-635c-75-53-340-262-834-392-413-109-1000-106-1039-106h-752l44 76s567 1 610 1c91 0 665 28 1075 300z",
    className: "fil0",
    id: "path6662"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6664"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24307 1613c501 269 997 641 1089 708 93 67 846 606 846 606s176 119 337 119c157 0 335-174 335-174s-1202-865-1310-941-541-431-1236-596c-544-138-1452-122-1515-122h-1100l44 76h960c199 0 966 10 1549 324z",
    className: "fil0",
    id: "path6666"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6668"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28663 1601c-148-26-343-38-343-38l-266 76-152-127s317 25 405 38c76 0 51-38 12-115-38-76-126-76-126-76h-799s-143 1-307-37c-165-38-230-162-230-162-64 147 190 318 190 318l791 567c102 64 190 13 190 13s203-102 317-127c102-25 418-38 456-25 89 13 190 102 190 102 51-356-178-379-329-407z",
    className: "fil1",
    id: "path6670"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6672"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24463 426c551 242 1339 831 1454 915 116 84 1251 897 1251 897s178 127 343 127 328-166 328-166-1604-1153-1720-1236-648-531-1637-792C23805-8 22641 0 22506 0h-1452l45 77h1331c336 0 1305 28 2034 349z",
    className: "fil1",
    id: "path6674"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6676"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24379 1018c-595-298-1329-335-1756-335h-1175l-44-76h1277c138 0 1105-10 1745 135 738 168 1373 652 1439 698 63 44 1520 1089 1520 1089s-166 171-345 171c-164 0-342-127-342-127s-948-680-1040-745c-91-65-725-534-1279-811z",
    className: "fil1",
    id: "path6678"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3053 4395s-89-20-197-20c-240 0-418 106-467 266-11 30-14 97-14 131 0 203 142 317 316 317 33 0 88-8 135-26 125-46 227-130 227-258zm165 908c-16 0-86 4-115-29-28-26-28-65-28-97v-102c-105 155-282 260-548 254-418-12-510-340-510-521 0-64 6-186 101-316 148-208 455-276 729-276 117 0 206 17 206 17v-183c0-65 0-176-65-254-56-65-159-114-342-114-285 0-472 161-472 161l34-216s193-131 503-131c259 0 438 71 543 177 121 126 151 242 151 474v1156z",
    className: "fil2",
    id: "path6682"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6684"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4370 3738c-300 57-333 294-333 461v1104h-352V3725c0-152-100-184-100-184h348c77 0 104 43 104 91v96c11-32 137-200 370-208 76-3 163 4 210 32l46 222c-52-29-150-64-294-37z",
    className: "fil2",
    id: "path6686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6688"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6059 5303c-12 0-85 4-118-29-26-26-26-74-26-97v-102c-95 155-266 253-501 253-184 0-309-42-418-160-115-128-144-287-144-502v-967c0-125-108-158-105-157h328c81 0 130 41 130 102v1062c0 314 93 403 313 403 181 0 378-122 378-309V3543h349v1761h-185z",
    className: "fil2",
    id: "path6690"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6692"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10878 5303c-73 0-117-31-117-120V3105c0-131-101-181-101-181h340c101 0 146 49 146 122v2258h-270z",
    className: "fil2",
    id: "path6694"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6696"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15674 3688c-355-4-417 362-417 752 0 485 122 717 417 717 260 0 382-300 382-717 0-340-32-748-382-752m-7 1641c-576-3-783-360-783-897 0-490 207-931 783-928 583 4 761 444 761 928 0 495-280 901-761 897z",
    className: "fil2",
    id: "path6698"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6700"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20929 5175c-125 106-290 158-474 160h-19c-276 0-427-74-493-112l-50-209s241 158 492 158c242 0 380-130 364-345-25-343-819-261-819-829 0-312 254-476 566-480h20c322 0 441 113 441 113l49 195s-138-136-414-136c-297 0-326 238-320 304 19 171 149 212 382 314 243 104 435 238 435 496 0 164-63 290-158 371z",
    className: "fil2",
    id: "path6702"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6704"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21405 5303c-65 0-100-34-100-92V3700c0-116-110-158-110-158h359c72 0 100 38 100 105v1656z",
    className: "fil2",
    id: "path6706"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6708"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11746 3542c67 0 101 32 101 91v138c96-156 267-255 501-255 184 0 309 42 418 161 115 129 144 287 144 503v1124h-210c-90 0-142-61-142-145V4142c0-314-94-403-312-403-181 0-379 122-379 310v1256h-349V3696c0-124-97-152-97-152h326z",
    className: "fil2",
    id: "path6710"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6712"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22919 4395s-89-20-198-20c-240 0-418 106-467 266-11 30-13 97-13 131 0 203 141 317 316 317 33 0 89-8 135-26 125-46 227-130 227-258zm165 908c-17 0-85 4-116-29-25-26-25-65-25-97v-102c-106 155-284 260-550 254-418-12-509-340-509-521 0-64 5-186 102-316 147-208 454-276 727-276 119 0 208 17 208 17v-183c0-65 10-168-63-255-53-67-165-115-355-113-326 6-461 161-461 161l35-216s192-131 502-131c259 0 437 71 542 177 122 126 151 242 151 474v1156h-187z",
    className: "fil2",
    id: "path6714"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6716"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7606 4135c0-100-13-246-93-330-56-59-144-100-270-100-342 0-381 455-381 700v26c3 347 102 691 388 691 155 0 263-60 356-177v-811zm109 1168c-69 0-93-23-93-87v-87c-132 118-260 196-453 199h-7c-503 0-678-425-678-897 0-354 136-928 695-928 335 0 428 202 428 202v-600c0-126-104-191-104-191h273c105 0 183 73 183 152v2237h-243z",
    className: "fil2",
    id: "path6718"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6720"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9250 4395s-88-20-197-20c-240 0-418 106-467 266-10 30-14 97-14 131 0 203 141 317 316 317 33 0 89-8 135-26 125-46 227-130 227-258zm164 908c-16 0-86 4-115-29-27-26-27-65-27-97v-102c-105 155-282 260-549 254-417-12-510-340-510-521 0-64 6-186 102-316 148-208 454-276 728-276 119 0 207 17 207 17v-183c0-65 0-176-65-254-55-65-159-114-341-114-285 0-473 161-473 161l35-216s193-131 502-131c260 0 438 71 543 177 121 126 151 242 151 474v1156z",
    className: "fil2",
    id: "path6722"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6724"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14287 4135c0-100-13-246-92-330-55-59-144-100-270-100-342 0-382 455-382 700v26c4 347 102 691 389 691 156 0 262-60 355-177v-811zm110 1168c-69 0-94-23-94-87v-87c-131 118-260 196-454 199h-9c-500 0-675-425-675-897 0-354 135-928 694-928 335 0 427 202 427 202v-600c0-126-103-191-103-191h274c105 0 182 73 182 152v2237z",
    className: "fil2",
    id: "path6726"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6728"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16904 3542c68 0 102 32 102 91v138c95-156 266-255 501-255 184 0 308 42 417 161 115 129 145 287 145 503v1124h-211c-89 0-141-61-141-145V4142c0-314-94-403-313-403-181 0-378 122-378 310v1256h-350V3696c0-124-97-152-97-152h324z",
    className: "fil2",
    id: "path6730"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6732"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1454 5315c-142 19-227 26-365 26-362 0-592-109-767-280C66 4807 0 4385 0 4121c0-213 36-631 378-953 158-148 404-274 773-274 329 0 487 94 487 94l61 218c-13-6-183-104-466-104-581 0-825 399-825 1020 0 939 457 1013 716 1013 184 0 258-29 258-29v-933h-202c-136 0-194 21-194 21l29-189h746v1243c-122 32-187 51-309 67z",
    className: "fil2",
    id: "path6734"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6736"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18683 4423s89 19 198 19c391 0 480-192 498-414 15-198-38-395-344-357-278 35-352 216-352 442 0 187 1 310 1 310m526-926c417 30 510 341 510 521 0 65-6 187-102 316-148 209-454 276-727 276-119 0-207-16-207-16v163c0 308 164 391 435 387 303-4 543-191 543-191l-34 216s-275 160-585 160c-260 0-456-69-560-177-129-134-151-314-151-546v-385c0-328 135-777 878-724z",
    className: "fil2",
    id: "path6738"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGarudaIndonesiaLogowine);
export default __webpack_public_path__ + "static/media/Garuda_Indonesia-Logo.wine.2f53b89b346d9be2e5fbf550de11f6f5.svg";
export { ForwardRef as ReactComponent };